import Constants from '@/Constants';
import { Group } from '@/models/Group';
import { useGet } from './useGet';

const getKey = (appId?: number, orgId?: number): string | null => {
    if (!appId || !orgId) {
        return null;
    }
    return `${Constants.GROUPS_RESULT_URI}?applicationId=${appId}&organizationId=${orgId}`;
};

export const useGroup = (applicationId: number, organizationId: number) => {
    const { data: response, loading, revalidateResult } = useGet<Group[]>(getKey(applicationId, organizationId));
    return { response, loading, revalidateResult };
};

const getKeyGroupId = (groupId: number = 0): string | null => {
    if (groupId === 0) {
        return null;
    }
    return `${Constants.GROUPS_RESULT_URI}/${groupId}`;
};

export const useGroupId = (groupId: number) => {
    const { data: group, loading: isLoading, revalidateResult } = useGet<Group>(getKeyGroupId(groupId));
    return { group, isLoading, revalidateResult };
};
